import React from 'react';
import AdSlot from 'components/ads/ad-slot';
import AdSlotCorner from 'components/ads/ad-slot-corner';
import MainLayout from './main-layout.base';
import HeaderDesktop from '../header/header.desktop';
import FooterDesktop from '../footer/footer.desktop';
import { SLOT_TOP, SLOT_SPONSORING_TOP, SLOT_SCROLLER, SLOT_CORNER } from 'components/ads/ad-slot/ad-defs';
import Container from 'atomic/container';
import { Head } from '@ecommerce/nest-ssr/components';

import './main-layout.desktop.scss';

const MainLayoutDesktop: React.FC = ({ children }) => (
    <>
        <Head>
            <meta name="viewport" content="width=device-width"/>
            <meta charSet="UTF-8"/>
        </Head>
        <AdSlot name={SLOT_SPONSORING_TOP} className="creation-topbar" resizable={true}/>
        <HeaderDesktop/>
        <Container>
            <AdSlot name={SLOT_TOP} className="creation-top"/>
        </Container>
        <MainLayout>
            {children}
        </MainLayout>
        <Container>
            <FooterDesktop/>
        </Container>
        <AdSlot name={SLOT_SCROLLER}/>
        <AdSlotCorner name={SLOT_CORNER}/>
    </>
);

export default MainLayoutDesktop;
